<script lang="ts" setup>
import { getEnv } from '@monogrid/env'
import VersionInfo from '@monogrid/vue-boost/core/VersionInfo.vue'
import { i18n as getI18n } from '@monogrid/vue-boost/i18n'
import { gsap } from 'gsap'
import { Draggable } from 'gsap/Draggable'
import { onBeforeMount } from 'vue'

import DefaultShareImage from '@/assets/images/share'
import { setupHead } from '@/composables/useHead'

import AppPage from './components/layout/AppPage.vue'

gsap.registerPlugin(Draggable)

const env = getEnv()
const { t } = getI18n()

setupHead({
  siteName: () => t('global.seo.title'),
  siteDescription: () => t('global.seo.description'),
  defaultImage: () => `https://${env.SERVICE_TARGET_DOMAIN}${DefaultShareImage.src}`
})

onBeforeMount(async () => {
  if ('fonts' in document) {
    await Promise.all([
      document.fonts.load('300 1em Nitti'),
      document.fonts.load('400 1em Nitti'),
      document.fonts.load('500 1em Nitti'),
      document.fonts.load('700 1em Nitti')
    ])
  }
})
</script>

<template>
  <div>
    <AppPage />
    <VersionInfo v-if="env.SERVICE_STAGE !== 'production'" />
  </div>
</template>

<style lang="scss">
@import "@/styles/main";

// tweakpane
.tp-dfwv {
  z-index: 100000 !important;
}
</style>
